var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalednderDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.508,
    height: 19.5,
    viewBox: "0 0 19.508 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44190",
    "data-name": "Group 44190",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88419",
    "data-name": "Path 88419",
    d: "M8.75,14.763h1.5m3.008,0h1.5m-10.509,0h1.5m3-3.375h1.5m3.008,0h1.5m-10.509,0h1.5M.5,7.625H18.508m-4.5-3.375V.5M5,4.25V.5m-1.492,18H15.5a3.009,3.009,0,0,0,3.008-3.009V5.008A3.008,3.008,0,0,0,15.5,2H3.508A3.008,3.008,0,0,0,.5,5.008V15.491A3.009,3.009,0,0,0,3.508,18.5Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalednderDate);
export default __webpack_public_path__ + "static/media/calednder-date.4fe247284f8b05bb6d464ddb0fe88b98.svg";
export { ForwardRef as ReactComponent };